import imageCompression from "browser-image-compression";
import { requestAssetPost } from "../api/assetInstance";

export const compressImage = async (file, maxSizeMb = 1) => {
  if (!file.type.startsWith("image/")) return file;
  if (file.size <= maxSizeMb * 1024 * 1024) return file; // Check if the file size is already within the limit

  // console.log(`Before compression: ${(file.size / 1024).toFixed(2)} KB`);

  const options = {
    maxSizeMb,
    maxWidthOrHeight: 1200,
    useWebWorker: true,
  };

  try {
    const compressedFile = await imageCompression(file, options);

    // console.log(
    //   `After compression: ${(compressedFile.size / 1024).toFixed(2)} KB`,
    // );

    return compressedFile;
  } catch (err) {
    console.error("Compression failed:", err);
    return file; // If compression fails, return the original file
  }
};

export const uploadFileToAsset = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  const response = await requestAssetPost("/", formData);
  return response?.data?.data?.url;
};
